<template>
  <div class="animated slideInLeft">
    <div class="tools_audio">
      <div class="flex_bet_h tools_titmod">
        <span class="tools_tit">选中音频</span>
        <img
          src="../../assets/images/img2/offlogin.png"
          class="tools_off"
          @click="hide"
        />
      </div>
      <div class="tools_aulist" @scroll="scrollList($event)">
        <div class="tools_auli upfilecon" v-loading="loading">
          <input
            type="file"
            name="file"
            id="upfile"
            accept=".mp3,.wav"
            @change="getFile($event)"
          />
          <img src="../../assets/images/img2/selfile.png" />
          <div>
            <p>从本地选择</p>
            <p class="tools_audesp">可拖动本地文件至此上传</p>
          </div>
        </div>
        <div
          class="tools_auli"
          v-for="(item, index) in work_list"
          :key="index"
          @click="setWork(item)"
        >
          <img
            src="../../assets/images/pause.png"
            @click.stop="play_audio.play(item.musicpath)"
            v-if="play_audio.audiourl == item.musicpath"
          />
          <img
            src="../../assets/images/play.png"
            @click.stop="play_audio.play(item.musicpath)"
            v-else
          />
          <div>
            <p>{{ item.wkname ? item.wkname : "未命名作品" }}</p>
            <p class="joint_mod_text">
              <span>{{ item.voiceauthor }}</span>
              <span>{{ item.bgname ? item.bgname : "无背景音" }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PlayListAudio from "../../utils/PlayListAudio.js";
export default {
  data() {
    return {
      page: 1, //作品分页
      work_list: [], //作品列表
      play_audio: new PlayListAudio(), //播放器对象
      lastPage: false, //是否最后一页
      loading: false, //加载动画显示状态
    };
  },
  destroyed() {
    this.play_audio.stop();
  },
  mounted() {
    this.getWorks(false);
  },
  methods: {
    // 从本地选择文件
    getFile(e) {
      let self = this;
      if (!(e.target.files[0].name.indexOf("mp3")!=-1 || e.target.files[0].name.indexOf("wav")!=-1)){
        self.$message({
          message: "文件格式错误！",
          type: "warning",
        });
        return
      }
      this.loading = true;
      this.$globalFun.getFile(e.target.files[0], (res) => {
        self.loading = false;
        console.log(res);
        if (res.data.model.ismax == "1") {
          self.$message({
            message: "文件大小大于20M，无法上传！",
            type: "warning",
          });
        }else if(res.data.model.ismax == "0"){
          let json = {
            musicpath : res.data.model.bgmusicurl
          }
          this.$emit("setWork", json);
        }else{
          self.$message.error('文件上传失败');
        }
      });
    },
    // 作品选择事件
    setWork(item) {
      this.$emit("setWork", item);
    },
    // 滑动触底事件
    scrollList(e) {
      const dom = e.target;
      var scrollTop = dom.scrollTop; //滑入屏幕上方的高度
      var windowHeitht = dom.clientHeight; //能看到的页面的高度
      var scrollHeight = dom.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht;
      if (total == scrollHeight) {
        this.getWorks(true);
      }
    },
    // 关闭点击
    hide() {
      this.$emit("hide");
    },
    // 获取作品列表
    getWorks(isadd) {
      // isadd？true=分页追加数据：false=覆盖列表数据
      let self = this;
      if (self.lastPage && isadd) return;
      if (isadd) this.page += 1;
      let json = {
        page: this.page,
        rows: 10,
      };
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qryworklist;
      this.$request.postHttp(json, url, (decData) => {
        self.lastPage = decData.model.lastPage;
        if (isadd) {
          self.work_list = self.work_list.concat(decData.model.list);
        } else {
          self.work_list = decData.model.list;
        }
      });
    },
  },
};
</script>

<style>
@import url("../../assets/css/tools.css");
</style>


// WEBPACK FOOTER //
// src/components/tools/audio_list.vue